import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-sync-medium",
  templateUrl: "./med-icon-sync-medium.component.html",
})
export class MedIconSyncMediumComponent extends SvgMixinComponent {}
